<template>
  <div>
    <v-container
      v-if="!isPayment"
      fluid
      glid-list-md
      >
      <v-row
        justify=center
        >
        <v-col
          md=8
          sm=10
          cols=12
          >
        <v-profile-edit-card
          v-if="isEdit"
          v-model="updateValue"
          @return-button-click="switchDisplayAndEdit"
          @update-button-click="update"
          @address-button-click="searchAddress"
          />
        <v-profile-display-card
          v-else
          :parent="parent"
          @edit-button-click="switchDisplayAndEdit"
          @card-info-button-click="isPayment=true"
          />
        </v-col>
      </v-row>
        <v-dialog
          :value="addressErr"
          width="400">
          <v-card
            class="main--text">
            <v-container
              fluid>
              <v-row
                justify=center>
                <v-col>
                  住所が見つかりませんでした。
                </v-col>
              </v-row>
              <v-row
                justify=center
                >
                <v-btn
                rounded
                outlined
                color="primary"
                @click="addressErr=false"
                >
                  OK
                </v-btn>
              </v-row>
            </v-container>
          </v-card>
        </v-dialog>
    </v-container>
    <v-container
      v-else
      fluid
      >
      <v-profile-payment-info
        v-model="parent.cardId"
        @ok-button-click="isPayment=false"
        />
    </v-container>
  </div>
</template>

<script>
import { ParentRepository} from "@/repository/ParentRepository.js"
import { firestore } from "@/repository/client/firestore.js"
import { getAddress } from "@/core/geocoding"
import VProfileDisplayCard from "@/components/organisms/parent/VProfileDisplayCard.vue"
import VProfileEditCard from "@/components/organisms/parent/VProfileEditCard.vue"
import VProfilePaymentInfo from "@/components/organisms/parent/VProfilePaymentInfo.vue"

export default {
  components: {
    VProfileDisplayCard,
    VProfileEditCard,
    VProfilePaymentInfo,
  },
  data() {
    return {
      parent: this.$store.getters.parent,
      isEdit: false,
      parentRepo: null,
      updateValue: {},
      addressErr: false,
      isPayment: false
    }
  },
  methods: {
    switchDisplayAndEdit () {
      this.isEdit = !this.isEdit
    },
    async update() {
      this.parent.name = this.updateValue.name
      this.parent.gender = this.updateValue.gender
      this.parent.birthday = this.updateValue.birthday
      this.parent.phone = this.updateValue.phone
      this.parent.address = this.updateValue.address
      this.parent.nearestStation = this.updateValue.nearestStation

      this.parent = await this.parentRepo.update(this.parent)
      this.$store.commit("loginAsParent", this.parent)
    },
    async searchAddress() {
      try {
        const result = await getAddress(this.updateValue.address.postalCode)
        this.updateValue.address.prefecture = result.prefecture
        this.updateValue.address.municipality = result.municipality
      } catch(e) {
        this.addressErr = true
      }
    }
  },
  created: function () {
    this.parentRepo = new ParentRepository(firestore)
    this.updateValue = {...this.parent}
  }
}
</script>
